    // import react { useEffect } from 'react'; 
    // import $ from 'jquery'
    import Header from '../components/Header'
    import News from '../components/News'
    import Copyright from '../components/Copyright'
    import SliderComponent from '../components/lightslider'
    import Events from '../components/Events' 
    import PrincipalMessage from '../components/PrincipalMessage' 
    import Birthday from '../components/Birthday' 
    import Topper from '../components/Topper' 
    import Footer from '../components/Footer'  
    import Notification from '../components/Notification'  
    import { Link, Navigate } from 'react-router-dom'    
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
    //import WOW from 'wow.js'; // Import WOW.js library
    const Home = () => {    
        var settings = {
            loop: true,
            margin: 10,
            responsiveClass: true,
            autoplay: true,
            dots: true,
            items: 1,
            responsive: {
                0: {
                    items: 1,
                },
                567: {
                    items: 1,
                },
                768: {
                    items: 1,
                },
                992: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
                1600: {
                    items: 1,
                }
            }
        };
        
        
        
        return(
            <>
            
                <Header></Header>
                <div className='notification'>
                <Notification />
                </div>
                {/* <div className='online-reg'>
                    <img src="/Images/registration.png" />
                </div> */}
                <div className='container-fluid min-ht'>
                    <div className="row">
                    
                        <div className='col-md-12 pd-0 order-lg-12'>
                            <SliderComponent />
                        </div> 
                    </div>
                                
                </div> 
                <div className='vision-mission'>
                    <div class="container">
                        <div className='row'>
                            
                            <div className='col-md-12 vision-mission-col animateMe' data-animation="fadeInRight">
                                <h3><img src='/Images/vision.gif'></img> Our vision</h3>
                                <p>Be a leading school in India, supplying qualified citizens to run the administrative machinery transparently, to shoulder the developmental tasks of the nation effectively, in scientific, medical, technological and other fields, enabling the development of villages where the heart of India lies.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-us">
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-12  animate__animated animate__slideInUp'>
                                <div className="title">
                                    <div class="title-gif">
                                        <img src='Images/about.gif'></img>
                                    </div>
                                        <h3>ABOUT SCHOOL</h3>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-12 animateMe'  data-animation="fadeInLeft">
                                <img src="Images/about-img.png" className='img-fluid' />
                            </div>
                            <div className='col-lg-6 col-md-12 animateMe'  data-animation="fadeInRight">
                                <p><span>ST. Thomas Sr. Sec. School, Civil Lines, Mainpuri </span>is a Catholic Christian, Minority educational institution, which was started in 1976 imparting education to all students irrespective of their sex, caste, creed and religion to strengthen inter religious, communal, cultural and social ties among the students, so that they learn to respect all religions and cultures in our country and strive to maintain unity in diversity as part of the God"s plan for ... Lush-green trees, resplendent flowers and extensive farmlands around offer it an idyllic setting and pollution-free environment. It is an institution where learning is a pleasurable pursuit, where hours spent happily in the playground give strength.</p>
                                <div className='button'><Link to="/about-us">READ MORE</Link></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='news-event'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-4 news-bg animateMe' data-animation="fadeInLeft">
                                <div className='news'>
                                <div className="title">
                                    <div class="title-gif">
                                        <img src='Images/news.gif'></img>
                                    </div>
                                        <h3>LATEST NEWS</h3>
                                </div> 
                                    <div className='news-blk'>
                                        <News />
                                        <div className='button'>
                                       <Link to="/news">VIEW ALL</Link>

                                        

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-8 animateMe' data-animation="fadeInRight">
                                <div className='events'>
                                    <div className='title'>
                                        <div className='title-gif'>
                                            <img src="Images/events.gif" />
                                        </div>
                                        <h3>Events & Updates</h3>
                                    </div>
                                    <div className='events-blk'>
                                        <Events />
                                        <div className='button'>
                                     <center>  <Link to="/events">VIEW ALL</Link>     </center>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="message">
                    <div className='container-fluid'>
                        <div class="row">
                            <div class="col-md-12">
                                <div className="title">
                                    <div class="title-gif">
                                        <img src='Images/message.gif'></img>
                                    </div>
                                    
                                    <h3>PRINCIPAL MESSAGE</h3>
                                </div> 
                                <OwlCarousel className='owl-theme' loop margin={10} {...settings}>
                                    <PrincipalMessage />
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="facilities">
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-12 col-md-12'>
                                <div className="title">
                                    <div class="title-gif">
                                        <img src='Images/facilities.gif'></img>
                                    </div>
                                        <h3>SCHOOL FACILITIES</h3>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-6 col-xs-12'>
                                <div className="faci-blk animateMe" data-animation="fadeInUpBig" >
                                    <img src="Images/smart-class.png" />
                                    <p>SMART CLASSES</p>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-6 col-xs-12'>
                                <div className="faci-blk animateMe" data-animation="fadeInUpBig">
                                    <img src="Images/library.png" />
                                    <p>SCHOOL LIBRARY</p>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-6 col-xs-12'>
                                <div className="faci-blk animateMe" data-animation="fadeInUpBig">
                                    <img src="Images/computer.png" />
                                    <p>COMPUTER LAB</p>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-6 col-xs-12'>
                                <div className="faci-blk animateMe" data-animation="fadeInUpBig">
                                    <img src="Images/chemistry.png" />
                                    <p>CHEMISTRY LAB</p>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-6 col-xs-12'>
                                <div className="faci-blk animateMe" data-animation="fadeInUpBig">
                                    <img src="Images/bio.png" />
                                    <p>BIOLOGY LAB</p>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-6 col-xs-12'>
                                <div className="faci-blk animateMe" data-animation="fadeInUpBig">
                                    <img src="Images/physics.png" />
                                    <p>PHYSICS LAB</p>
                                </div>
                            </div>
                        </div>
                    </div>                
                </div>
                <div className="school-activities">
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-12 col-md-12'>
                                <div className="title">
                                    <div class="title-gif">
                                        <img src='Images/activity.gif'></img>
                                    </div>
                                        <h3>SCHOOL ACTIVITIES</h3>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <div className="activity-blk animateMe" data-animation="fadeInUpBig">
                                    <h5>School<br /> Parliament</h5>
                                    <img src="Images/parliament.png" />
                                    <p>To develop leadership qualities among the children, election to the school parliament is held every year. It is aimed at familiarizing children with the process of election, democratic values and knowledge of election procedures. The school captain and vice-captain are elected directly by the children through direct voting in the most democratic way.</p>
                                </div>
                            </div>  
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <div className="activity-blk animateMe" data-animation="fadeInUpBig">
                                    <h5>Morning Assembly <br />& Prayer</h5>
                                    <img src="Images/prayer.png" />
                                    <p>Every day begins with assembly and prayer. This is compulsory for all the children. However physically challenged and sick may be exempted on request.</p>
                                </div>
                            </div>  
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <div className="activity-blk animateMe" data-animation="fadeInUpBig">
                                    <h5>Art &<br /> Craft</h5>
                                    <img src="Images/art-craft.png" />
                                    <p>Art and craft education has an important role in the school curriculum, as it develops the creative and imaginative sense of students. In order to promote this, there are separately allotted and special coaching for dance, music and drawing. Various competitions are held as an encouragement toward this. Every year cultural day is celebrated and opportunities are provided to students to perform on the stage before an audience.</p>
                                </div>
                            </div>  
                            <div className='col-lg-3 col-md-3 col-sm-12'>
                                <div className="activity-blk animateMe" data-animation="fadeInUpBig">
                                    <h5>Clubs &<br /> Association</h5>
                                    <img src="Images/club-association.png" />
                                    <p>To widen the scope and areas of co curricular activities, a number of Clubs and Association are formed and a number of programmes and activities are held under the auspices of Clubs and Associations viz. Science Club, Sports Club, Nature Club, Quiz and Cultural Association. As part of the activities of these Clubs, they organize Seminars, Talks, Experiments, Debates, Educational Tours and Quiz Competitions.</p>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className='birth-topper'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 animateMe"  data-animation="fadeInLeft">
                                <div className='birthday'>
                                    <div className="title">
                                        <div class="title-gif">
                                            <img src='Images/birthday.gif'></img>
                                        </div>
                                            <h3>BIRTHDAYS</h3>
                                    </div>
                                    <Birthday />
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8 animateMe"  data-animation="fadeInRight">
                                <div className='topper'>
                                    <div className="title">
                                        <div class="title-gif">
                                            <img src='Images/trophy.gif'></img>
                                        </div>
                                            <h3>SCHOOL TOPPERS</h3>
                                    </div>
                                    <Topper />  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='gallery'>
                <div className="title">
                        <div class="title-gif">
                            <img src='Images/gallery.gif'></img>
                        </div>
                            <h3>Gallery</h3>
                    </div>
                    <div className='container-fluid animateMe' data-animation="fadeInUpBig">
                        <div className='row'>
                            <div className="col-lg-4 col-sm-6">
                                <img src="Images/gallery1.JPG" className='img-fluid lg-mid' />
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <img src="Images/gallery2.JPG" className='img-fluid lg-small' />
                                <img src="Images/gallery4.JPG" className='img-fluid lg-small' />
                            </div>
                            <div className="col-lg-4">
                                <img src="Images/gallery3.JPG" className='img-fluid lg-mid' />
                            </div>
                            
                            <div className="col-lg-12">
                                <div className='button'>
                                    <a href="/Gallery">VIEW ALL</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
                <Copyright />
            </>
        )
    } 
    export default Home;